var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgF1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#C4C4C4;}\r\n\t.st1{fill:#616160;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#C4C4C4;stroke:#616160;stroke-miterlimit:10;}\r\n\t.st4{fill:#FFFFFF;stroke:#616160;stroke-miterlimit:10;}\r\n\t.st5{fill:#616160;stroke:#616160;stroke-width:0.25;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:#616160;stroke-miterlimit:10;stroke-dasharray:2.0068,2.0068;}\r\n\t.st7{fill:#616160;stroke:#616160;stroke-miterlimit:10;}\r\n\t.st8{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st9{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st10{fill:#C4C4C4;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st11{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;stroke-dasharray:1.9724,1.9724;}\r\n\t.st12{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.5,17.5h-13c-0.552,0-1-0.448-1-1v-13c0-0.552,0.448-1,1-1h13c0.552,0,1,0.448,1,1v13 C17.5,17.052,17.052,17.5,16.5,17.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.5,18h-13C2.673,18,2,17.327,2,16.5v-13C2,2.673,2.673,2,3.5,2h13C17.327,2,18,2.673,18,3.5v13 C18,17.327,17.327,18,16.5,18z M3.5,3C3.225,3,3,3.224,3,3.5v13C3,16.775,3.225,17,3.5,17h13c0.275,0,0.5-0.225,0.5-0.5v-13 C17,3.224,16.775,3,16.5,3H3.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15.529,17.029H4.471c-0.827,0-1.5-0.673-1.5-1.5V4.47c0-0.827,0.673-1.5,1.5-1.5h11.059 c0.827,0,1.5,0.673,1.5,1.5v11.059C17.029,16.356,16.356,17.029,15.529,17.029z M4.471,3.97c-0.275,0-0.5,0.224-0.5,0.5v11.059 c0,0.275,0.225,0.5,0.5,0.5h11.059c0.275,0,0.5-0.225,0.5-0.5V4.47c0-0.276-0.225-0.5-0.5-0.5H4.471z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.028,13.205h-1.34V6.78h3.683v1.116H7.028v1.656h2.18v1.112h-2.18V13.205z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.537,13.205h-1.358V9.487l0.014-0.61l0.021-0.668c-0.226,0.226-0.382,0.373-0.47,0.443l-0.738,0.594 l-0.655-0.818l2.07-1.647h1.116V13.205z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF1);
export default __webpack_public_path__ + "static/media/_F1.1ba30ba955aa6e69a3275afdd35373e9.svg";
export { ForwardRef as ReactComponent };